var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.85693 3.75112C2.85693 2.46903 3.89627 1.42969 5.17836 1.42969H14.8212C16.1033 1.42969 17.1426 2.46902 17.1426 3.75112V12.4145C17.0566 12.472 16.975 12.5388 16.8991 12.6147L16.0712 13.4425V3.75112C16.0712 3.06076 15.5116 2.50112 14.8212 2.50112H5.17836C4.48801 2.50112 3.92836 3.06076 3.92836 3.75112V16.2509C3.92836 16.9413 4.48801 17.5009 5.17836 17.5009H10.941L12.0124 18.5723H5.17836C3.89627 18.5723 2.85693 17.533 2.85693 16.2509V3.75112Z",
    fill: "url(#paint0_linear_1798_40787)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50007 6.24833C7.50007 6.74144 7.10033 7.14118 6.60721 7.14118C6.1141 7.14118 5.71436 6.74144 5.71436 6.24833C5.71436 5.75521 6.1141 5.35547 6.60721 5.35547C7.10033 5.35547 7.50007 5.75521 7.50007 6.24833Z",
    fill: "url(#paint1_linear_1798_40787)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60721 10.8912C7.10033 10.8912 7.50007 10.4915 7.50007 9.99833C7.50007 9.50525 7.10033 9.10547 6.60721 9.10547C6.1141 9.10547 5.71436 9.50525 5.71436 9.99833C5.71436 10.4915 6.1141 10.8912 6.60721 10.8912Z",
    fill: "url(#paint2_linear_1798_40787)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60721 14.6412C7.10033 14.6412 7.50007 14.2415 7.50007 13.7483C7.50007 13.2552 7.10033 12.8555 6.60721 12.8555C6.1141 12.8555 5.71436 13.2552 5.71436 13.7483C5.71436 14.2415 6.1141 14.6412 6.60721 14.6412Z",
    fill: "url(#paint3_linear_1798_40787)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.107 5.71484C8.81115 5.71484 8.57129 5.95469 8.57129 6.25056C8.57129 6.54642 8.81115 6.78627 9.107 6.78627H13.7499C14.0457 6.78627 14.2856 6.54642 14.2856 6.25056C14.2856 5.95469 14.0457 5.71484 13.7499 5.71484H9.107Z",
    fill: "url(#paint4_linear_1798_40787)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57129 10.0006C8.57129 9.7047 8.81115 9.46484 9.107 9.46484H13.7499C14.0457 9.46484 14.2856 9.7047 14.2856 10.0006C14.2856 10.2964 14.0457 10.5363 13.7499 10.5363H9.107C8.81115 10.5363 8.57129 10.2964 8.57129 10.0006Z",
    fill: "url(#paint5_linear_1798_40787)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.107 13.2148C8.81115 13.2148 8.57129 13.4547 8.57129 13.7506C8.57129 14.0464 8.81115 14.2863 9.107 14.2863H13.7499C14.0457 14.2863 14.2856 14.0464 14.2856 13.7506C14.2856 13.4547 14.0457 13.2148 13.7499 13.2148H9.107Z",
    fill: "url(#paint6_linear_1798_40787)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4145 14.1293L14.1287 18.415C14.0283 18.5155 13.892 18.572 13.75 18.572C13.6079 18.572 13.4716 18.5155 13.3712 18.415L11.2297 16.2736C11.0205 16.0644 11.0205 15.7252 11.2297 15.516C11.4389 15.3068 11.7781 15.3068 11.9873 15.516L13.75 17.2786L17.6569 13.3718C17.8661 13.1625 18.2052 13.1625 18.4145 13.3718C18.6237 13.581 18.6237 13.9201 18.4145 14.1293Z",
    fill: "url(#paint7_linear_1798_40787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40787",
    x1: 9.99979,
    y1: 1.42969,
    x2: 9.99979,
    y2: 18.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4880E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40787",
    x1: 6.60721,
    y1: 5.35547,
    x2: 6.60721,
    y2: 7.14118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4880E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40787",
    x1: 6.60721,
    y1: 9.10547,
    x2: 6.60721,
    y2: 10.8912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4880E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40787",
    x1: 6.60721,
    y1: 12.8555,
    x2: 6.60721,
    y2: 14.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4880E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1798_40787",
    x1: 11.4284,
    y1: 5.71484,
    x2: 11.4284,
    y2: 6.78627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4880E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1798_40787",
    x1: 11.4284,
    y1: 9.46484,
    x2: 11.4284,
    y2: 10.5363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4880E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1798_40787",
    x1: 11.4284,
    y1: 13.2148,
    x2: 11.4284,
    y2: 14.2863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4880E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1798_40787",
    x1: 14.8221,
    y1: 13.2148,
    x2: 14.8221,
    y2: 18.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4880E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/tasks-icon.a2e405d64e4fd1991873a5533adf631d.svg";
export { ForwardRef as ReactComponent };